import React from 'react';
import { FaLinkedinIn } from 'react-icons/fa';
import logoBlack from "../assets/images/logo_black.PNG";

function Footer() {
    return (
        <footer style={footerStyles}>
            <div style={footerTop}>
                <div style={footerLeft}>
                    <img
                        src={logoBlack}
                        alt="Dataqly"
                        style={{
                        height: "2rem",
                        width: "auto",
                        display: "block",
                        }}
                    />
                    <div style={brandDesc}>Specialized in Data & AI solutions.</div>
                    <a href="https://www.linkedin.com/company/dataqly" target="_blank" rel="noopener noreferrer" style={linkedinBtn} aria-label="LinkedIn">
                        <FaLinkedinIn size={22} />
                    </a>
                </div>
                <div style={footerRight}>
                </div>
            </div>
            <div style={footerBottom}>
                <div style={footerCopyright}>© Dataqly. All Rights Reserved.</div>
                <div style={footerLinks}>
                    <a href="#" style={footerLink}>Terms & Conditions</a>
                    <span style={footerLinkDivider}>|</span>
                    <a href="#" style={footerLink}>Privacy Policy</a>
                </div>
            </div>
        </footer>
    );
}

const footerStyles = {
    background: '#fff',
    color: '#18171b',
    fontFamily: 'Inter, sans-serif',
    fontSize: 15,
    borderTop: '1px solid #e5e8f0',
    marginTop: 64,
    padding: '0',
};
const footerTop = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '48px 0 24px 0',
    maxWidth: 1200,
    margin: '0 auto',
    width: '95%',
    gap: 32,
};
const footerLeft = {
    flex: 1,
    minWidth: 220,
};
const brandName = {
    fontWeight: 700,
    fontSize: 24,
    marginBottom: 8,
    letterSpacing: 0.2,
};
const brandAccent = {
    fontSize: 22,
    fontWeight: 400,
    marginLeft: 2,
};
const brandDesc = {
    color: '#6b6b6b',
    fontSize: 15,
    marginBottom: 24,
    lineHeight: 1.5,
};
const linkedinBtn = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f3f3f3',
    borderRadius: '50%',
    width: 38,
    height: 38,
    color: '#18171b',
    textDecoration: 'none',
    fontWeight: 700,
    fontSize: 18,
    marginBottom: 0,
    marginTop: 0,
};
const footerRight = {
    flex: 2,
    display: 'flex',
    justifyContent: 'flex-end',
    minWidth: 320,
};
const footerMenuContact = {
    display: 'flex',
    flexDirection: 'row',
    gap: 64,
};
const footerMenuCol = {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    minWidth: 120,
};
const footerMenuTitle = {
    fontWeight: 600,
    fontSize: 15,
    color: '#888',
    marginBottom: 2,
};
const footerMenuItem = {
    fontWeight: 400,
    fontSize: 15,
    color: '#18171b',
    marginBottom: 0,
};
const footerLink = {
    color: '#18171b',
    textDecoration: 'none',
    fontWeight: 400,
};
const footerBottom = {
    borderTop: '1px solid #e5e8f0',
    marginTop: 32,
    padding: '18px 0 10px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: 1200,
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '95%',
    fontSize: 14,
};
const footerCopyright = {
    color: '#6b6b6b',
};
const footerLinks = {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
};
const footerLinkDivider = {
    color: '#bdbdbd',
    margin: '0 8px',
};

export default Footer;
